import { operatorUserConstant } from '../../constants/operatorUser_constant'

const initialState = {
  showResults: false,
  loadingResults: false,
  results: [],
}

export function operatorUserReducer(state = initialState, action) {
  switch (action.type) {
    case operatorUserConstant.GET_ALL_REQUEST:
      return {
        ...state,
        loadingResults: true,
        showResults: false,
      }
    case operatorUserConstant.GET_ALL_SUCCESS:
      return {
        ...state,
        loadingResults: false,
        showResults: true,
        results: action.results,
      }
    case operatorUserConstant.GET_ALL_FAILURE:
      return {
        ...state,
        loadingResults: false,
        results: [],
        error: action.error,
      }
    default:
      return state
  }
}
